<template>
  <div class="k8m-cluster-table-wrapper">
    <div class="k8m-cluster-table-graph-container">
      <div v-if="nodeOverviewConfig && nodeChartConfig">
        <K8ClusterNodeOverview
          :tableConfigs="nodeOverviewConfig"
          :mapConfigs="nodeChartConfig"
        />
      </div>
      <div
        class="k8m-cluster-table-chart-element"
        v-for="(tableConfig, index) in tablesConfig"
        :key="'table' + index"
      >
        <TableBuilder
          :tableConfig="tableConfig"
          :scope="scope"
          :maxPageSize="5"
          :enableInfiniteScroll="false"
          :defaultSortKey="tableConfig.defaultSortKey"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {
  K8ClusterTablesConfig,
  K8NodeOverviewConfig,
} from '@/components/K8M/Cluster/cluster.table.config';
import { k8mClusterGraphs } from '@/components/K8M/Cluster/cluster.graph.config';
import TableBuilder from '@/components/K8M/Common/TableBuilder.vue';
import K8ClusterNodeOverview from '@/components/K8M/Cluster/ClusterNodeOverview.vue';
import { k8Scopes } from '@/store/modules/k8/k8-types';

export default {
  name: 'ClusterTable',
  components: {
    TableBuilder,
    K8ClusterNodeOverview,
  },
  data() {
    return {
      scope: k8Scopes.SERVICE,
      isTable: true,
    };
  },
  computed: {
    tablesConfig() {
      return K8ClusterTablesConfig();
    },
    nodeOverviewConfig() {
      return K8NodeOverviewConfig();
    },
    nodeChartConfig() {
      return k8mClusterGraphs().node.lineCharts;
    },
  },
  methods: {
    onClickToggle(data) {
      this.isTable = !data;
    },
  },
};
</script>

<style lang="scss" scoped>
.k8m-cluster-table-wrapper {
  @include flex-row-wrap;
  position: relative;
  margin-top: 1.438em;
  margin-right: 0.8rem;
}
.k8m-cluster-table-graph-container {
  width: 100%;
}
.k8m-cluster-table-chart-element {
  width: 100%;
  // height: 30em;
  margin-bottom: 1.5em;
  margin-top: 0.125em;
  margin-left: 0.125em;
}
</style>
